import { useTranslation } from 'next-i18next'
import React from 'react'

import { useLocaleContext } from '@src/components/locale/locale.context'
import { Modal } from '@src/quince-components/src'
import QRCanvas from '@src/quince-components/src/atoms/qrCanvas/QRCanvas'
import Product from '@src/quince-site-common/src/domains/Product'
import { ProductVariantOption } from '@src/quince-site-common/src/domains/ProductVariant'
import QuinceLogo from '@src/quince-site-common/src/organisms/appLayout/molecules/header/icons/quince-q-logo.svg'
import { getlbUserId } from '@src/quince-site-common/src/utils/getlb-user-id'

import { buildAppDeepLinkUrl, buildPageUrl } from '../utils/appLink.utils'

import styles from './appQrModal.module.scss'

const DEFAULT_DESCRIPTION_KEY = 'only_in_the_app_description'
const DEFAULT_SCAN_LABEL_KEY = 'scan_to_download'
// @i18n-ignore-end

export interface AppQRModalProps {
  isOpen: boolean
  onClose: () => void
  product?: Product
  selectedOptions?: ProductVariantOption[]
  path?: string
  descriptionKey?: string
  scanLabelKey?: string
  onelinkBase?: string | null
}

// If product is provided, it create link with that product and selected options. Otherwise it uses window.location.href
function AppQRModalLegacy({
  isOpen,
  onClose,
  product,
  selectedOptions,
  path,
  descriptionKey = DEFAULT_DESCRIPTION_KEY,
  scanLabelKey = DEFAULT_SCAN_LABEL_KEY,
  onelinkBase,
}: AppQRModalProps) {
  const { t } = useTranslation('common')
  const { locale } = useLocaleContext()

  const lbUserId = getlbUserId() ?? ''
  const pageLink = buildPageUrl({ locale, path, product, selectedOptions, lbUserId })
  const appQRLink = buildAppDeepLinkUrl(pageLink, onelinkBase)

  return (
    <Modal
      open={isOpen}
      modalWrapperClassName={styles.modalWrapper}
      className={styles.modalClassName}
      showCloseButton
      onClose={onClose}
    >
      <div className={styles.wrapper}>
        <div className={styles.contentWrapper}>
          <QuinceLogo width={'5.6rem'} height={'5.6rem'} className={styles.appPushBanner__logo} />
          <h2 className={styles.heading}>{t('only_in_the_app')}</h2>
          <div className={styles.description}>{t(descriptionKey)}</div>
          <QRCanvas url={appQRLink} widthInRem={12.6} />
          <div className={styles.subText}>{t(scanLabelKey).toUpperCase()}</div>
        </div>
      </div>
    </Modal>
  )
}

export default AppQRModalLegacy
